import logger from "redux-logger";
import createSagaMiddleware from "@redux-saga/core";
import rootReducer from "../reducers";

import rootSaga from "../sagas";
import { configureStore } from "@reduxjs/toolkit";

function customStore(enableLogger = true) {
  const sagaMiddleware: any = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware({
        immutableCheck: false
      }).concat(sagaMiddleware);
      if (enableLogger) {
        middleware.push(logger);
      }
      return middleware;
    }
  });
  sagaMiddleware.run(rootSaga);
  return store;
}

export default customStore;
